export default "__VITE_ASSET__e130325a__"